/* DO NOT TRANSFER OR RENAME FILE. Make a merge request to the widget template to modify. */
import type {
	AddCatchWidgetApiDisposeFaults,
	AddCatchWidgetApiInitDisposeFaults,
	AddCatchWidgetApiInitFaults,
	AddFixWidgetApiDisposesFaults,
	AddFixWidgetApiDisposesInitFaults,
	InitWidget,
	WidgetInitResult,
} from '@skbkontur/loader-builder';
import type {Guid} from './Guid.js';
import type {InitParams} from './InitParams.js';

export enum CandyWidgetFeature {
	HistoryEditing ="HistoryEditing"
}

export type ImportDependencies = {
	readonly workspaceId: Guid;
	readonly apiUrl: string;
	readonly apiKey: string;
	readonly resourceZone: string | undefined;
	readonly cabinetApiUrl: string | undefined;
	readonly widgetFeature: CandyWidgetFeature;
};

export type WidgetImportFaults =
	| {
			readonly type: 'init-state-setup';
			readonly message: string;
	  }
	| {
			readonly type: 'initialize-context';
			readonly message: string;
			readonly traceId: string | null;
			readonly code: string;
			readonly target: string | null;
	  };

export type GetJsLoaderDependenciesFaults = {
	readonly type: 'validation';
	readonly message: string;
};

export type InitDisposeFaults = AddCatchWidgetApiInitDisposeFaults<never>;

export type DisposeFaults = AddFixWidgetApiDisposesFaults<AddCatchWidgetApiDisposeFaults<never>, InitDisposeFaults>;

export type WidgetApi = {
	readonly init: InitWidget<
		InitParams,
		AddFixWidgetApiDisposesInitFaults<AddCatchWidgetApiInitFaults<never>>,
		WidgetInitResult<InitDisposeFaults>
	>;
};
